export class ApiError extends Error {
  status: number;
  code?: string;
  details?: Record<string, unknown>;
  data?: unknown;
  constructor(
    message: string,
    status: number,
    opts: { code?: string; details?: Record<string, unknown>; data?: unknown } = {},
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = opts.code;
    this.details = opts.details;
    this.data = opts.data;
  }
}

export class UnauthorizedError extends ApiError {
  constructor(message = 'Unauthorized', data?: unknown) {
    super(message, 401, { data });
    this.name = 'UnauthorizedError';
  }
}

type Envelope = {
  error?: { code?: string; message?: string; details?: Record<string, unknown> };
};

export function parseApiError(
  status: number,
  data: unknown,
  fallbackMessage = 'Request failed',
): ApiError {
  const envelope = (data ?? undefined) as Envelope | undefined;
  const error = envelope?.error;
  return new ApiError(error?.message ?? fallbackMessage, status, {
    code: error?.code,
    details: error?.details,
    data,
  });
}
